<template>
    <section class="beeldweb-wrapper light purple">
        <v-circlebg></v-circlebg>
        <h1>Highlights <br/>2020</h1>

        <v-sliderpage ref="sliderPage">
            <section class="beeldweb">
                <div class="bol-wrapper" @click.self="closePopup">

                    <div v-for="(project, index) in projects"
                         :class="{ 'bol': true, 'big': project.big }"
                         :style="{ backgroundImage: 'url( /static/img/pages/beeldweb/' + project.img + '.jpg )' }"
                         @click="openPopup( index, $event )" >
                    </div>

                </div>
                <transition name="fade">
                    <div v-if="popupIsOpen" class="popup-wrapper">
                        <div class="smart-popup" ref="smartPopup">
                            <h3>{{ popupTitle }}</h3>
                            <p>{{ popupDescription }}</p>
                            <!-- <button>Bekijk dit project</button> -->
                        </div>
                    </div>
                </transition>
            </section>
        </v-sliderpage>
    </section>
</template>

<style lang="scss" scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
         opacity: 0;
    }
</style>

<script>
    import SliderPage from '@/app/components/SliderPage';
    import CircleBg from '@/app/components/circles';

    import Vue from 'vue';
    import { gsap } from '@/vendor';

    export default {
        name: 'HighlightBeeldweb',
        meta: {
            title: 'Duurzaam verbeteren',
            color: '#a5147e'
        },
        components: {
            'v-sliderpage': SliderPage,
            'v-circlebg': CircleBg
        },

        data()
        {
            return {
                isMounted: false,

                projects: [
                    {
                        big: false,
                        title: 'Mohadesa Bahrami Ambassadeur ROC Tilburg',
                        description: 'Mohadesa Bahrami van de School voor Onderwijs en Kinderopvang is de Ambassadeur 2020 van ROC Tilburg. Zij wist met haar nooit aflatende doorzettingsvermogen de jury te overtuigen. Hendrik de Kok, Ambassadeur ROC Tilburg en ook landelijk mbo-ambassadeur 2019 droeg het stokje aan haar over.',
                        img: 'mohadesa'
                    },
                    { big: true, title: 'Robots', description: 'In de technische sector wordt smart industry steeds belangrijker. Het technische onderwijs kan daarom niet achterblijven. Bij ROC Tilburg staan zes robots die mechatronica-studenten voorbereiden op hun toekomst in de techniek.', img: 'robots' },

                    { big: false, title: 'Studenten 2e op hackaton', description: 'Vier studenten van de School voor ICT en Mediatechnologie wonnen de tweede plaats op de hackathon van de Den Bosch Dataweek. Ze namen het op tegen hbo- en universiteitsstudenten en groepjes professoren.', img: 'hackathon' },

                    { title: 'Arian ontvangt Hand Medal', description: '100 zorgmedewerkers van het Elisabeth-TweeSteden Ziekenhuis ontvingen een Hand Medal. Deze onderscheiding is bedoeld als schouderklopje voor zorgmedewerkers.​​​​​​​ Vierdejaars student verpleegkunde Arian is één van de gelukkige. “Het is iets speciaals,” vertelt hij,  “zeker omdat het een wereldwijd initiatief is.”', img: 'arian' },

                    { title: 'Blije taalcursisten', description: "Anderstalige werknemers van Coolblue hebben in samenwerking met de School voor Educatie en Inburgering de kans gekregen om de Nederlandse taal te leren of hun Nederlandse taalniveau te verhogen. Dit incompany-traject heeft ervoor gezorgd dat de medewerkers instructies van collega's beter op kunnen volgen, zich zelfverzekerder voelen binnen het team en beter kunnen participeren in de maatschappij.", img: 'taalcursisten' },

                    { title: 'Stage Vietnam', description: 'Zeven studenten en één docent zijn begin maart naar Vietnam vertrokken voor een stage. Helaas werden na enkele dagen de activiteiten in het buitenland stilgelegd door de Corona-maatregelen. Toch hebben onze studenten in korte tijd veel werk bij de basisschool  kunnen verzetten. De opbrengst? Een nieuwe keuken, een geweldig speelplein en een prettige eetzaal.', img: 'vietnam' },

                    { title: 'Burgemeesters in de kapsalon', description: 'De burgemeesters van de gemeente Oisterwijk en Gilze Rijen waren op 14 september op bezoek in de kapsalon. Zij gingen in gesprek met studenten over de effecten van corona, hun stage en werk. Zittend in de kapstoel werden ze tijdens het gesprek meteen gestyled! Uiteenlopende onderwerpen kwamen tijdens het gesprek aan bod: het tekort aan stageplaatsen voor mbo-ers, de sluiting van de salons in het voorjaar en hun kansen op de arbeidsmarkt.', img: 'burgemeester' },

                    { title: 'In gesprek met minister van Engelshoven', description: 'Op 5 oktober vond een gesprek plaats met minister van Engelshoven (minister van Onderwijs, Cultuur en Wetenschap), Kennispact MBO en de provincie Brabant. Drie van onze studenten waren erbij om uitleg te geven over hun eigen situatie. Want mbo-studenten hebben soms moeite om een stageplek te vinden in deze coronatijd.', img: 'minister' },

                    { title: 'Nieuw! Practoraat Mindlabs', description: 'ROC Tilburg selecteerden acht docenten die technologieën als VR, AR, serious gaming, robotica en avatars zien als belangrijke instrumenten voor het onderwijs van de toekomst. Het practoraat richt zich op het gebruik van interactieve technologieën in het onderwijs, gecombineerd met andere, meer traditionele werkvormen zoals klassikale lessen, practica en opdrachten.', img: 'practoraat' },

                    { title: ' Nieuw Practicumlokaal Procestechniek', description: 'De School voor Procestechniek is supertrots op hun nieuwe geavanceerde practicumlokaal. Studenten van Procestechniek werken er ook samen met studenten Werktuigbouwkunde en Mechatronica. De koppeling en samenwerking van onderwijs en het bedrijfsleven kan hiermee nog verder uitgebouwd worden.', img: 'practicumlokaal' },

                    { title: 'Minister Van Engelshoven op bezoek bij Hendrik de Kok', description: 'Op maandag 6 juli liep minister van Engelshoven (minister van Onderwijs, Cultuur en Wetenschap) een dag mee met onze landelijk mbo-ambassadeur van 2019, Hendrik de Kok. Dat deed ze op zijn stage-adres: het Elisabeth-TweeSteden Ziekenhuis in Tilburg.', img: 'ministerHendrik' },

                    { title: 'De Schuurschool bij Coolblue', description: 'In het Coolblue-magazijn, ook wel de Schuur, zijn 20 studenten gestart aan de opleiding Logistiek Teamleider niveau 3. Zij krijgen niet alleen lessen van onze docenten, maar ook van Coolblue’ers die graag hun expertise willen delen. De eerste gastles werd verzorgd door Pieter Zwart, één van de oprichters van Coolblue. Wanneer de studenten hun diploma hebben gehaald, krijgen ze een vaste baan bij Coolblue.', img: 'coolblue' },

                    { title: 'Studenten Adviespunt 013', description: 'Het beste onderwijs van Nederland verzorgen. Aan die ambitie van Onderwijsgroep Tilburg levert ons nieuwe Studenten Adviespunt 013 een belangrijke bijdrage. Het is dé plek voor leerlingen, studenten en medewerkers met vragen over voorlichting, werving, opleidingen, aanmelding, inschrijving, studieadvies en andere schooloverstijgende zaken.', img: 'afscheid' },

                    { title: 'Nieuwe schoonheidssalon', description: 'De Schoonheidssalon van de opleiding Schoonheidsverzorging is verbouwd en vernieuwd. De studenten zijn enthousiast over het moderne lokaal. Kim, derdejaars student niveau 4, vindt het super. “Het is ook echt mijn smaak. Ik kwam al met plezier naar school. Maar nu … echt fijn om in zo’n schoonheidssalon te kunnen werken en leren.”', img: 'salon' },

                    { big: true, title: 'Kirsten Cuppen genomineerd voor Leraar van het Jaar', description: 'Kirsten Cuppen, docent Nederlands en rekenen en Loopbaanbegeleider van de School voor Mechatronica, Werktuigbouwkunde en Metaaltechniek is genomineerd voor Leraar van het Jaar 2021. Inmiddels weten we ook dat Kirsten bij de eerste 3 zit. In de december 2021 volgt de bekendmaking.', img: 'kirsten' }

                    // { title: 'Lorem Ipsum', description: 'Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim.', img: 'small9' }
                ],

                popupIsOpen: false,
                popupTitle: '',
                popupDescription: ''
            };
        },

        computed: {
            offset()
            {
                if( !this.isMounted )
                {
                    return;
                }

                return this.$refs.sliderPage.offset;
            }
        },

        watch: {
            offset()
            {
                this.fixPopupOffset();
            }
        },

        mounted()
        {
            this.isMounted = true;
            this.openedAtOffset = 0;
        },

        methods: {
            focus()
            {
                // console.log( 'focus' );
            },
            openPopup( pIndex, e )
            {
                // set content
                this.popupTitle = this.projects[ pIndex ].title;
                this.popupDescription = this.projects[ pIndex ].description;

                // open
                this.popupIsOpen = true;

                // set position
                Vue.nextTick( () =>
                {
                    // must be next tick, since you can't tween a null target. Popup is null because of the v-if and it gets rendered in the next update tick

                    let prev = this.$el.querySelector( '.bol.selected' );
                    if( prev )
                    {
                        prev.classList.remove( 'selected' );
                    }

                    e.target.classList.add( 'selected' );

                    let boundingRect = e.target.getBoundingClientRect();
                    let pos = {
                        x: boundingRect.left + boundingRect.width / 2,
                        y: boundingRect.top + boundingRect.height / 2
                    };

                    gsap.set( this.$refs.smartPopup, {
                        left: pos.x,
                        top: pos.y
                    });

                    // ----------------
                    // solve offset (top/bottom and left/right) and set border-radius
                    // ----------------

                    // reset border radius
                    gsap.set( this.$refs.smartPopup, {
                        'border-top-left-radius': '2rem',
                        'border-top-right-radius': '2rem',
                        'border-bottom-left-radius': '2rem',
                        'border-bottom-right-radius': '2rem'
                    });

                    // determine styleTag for border-radius
                    let styleTag = 'border-';
                    let posAdustment = { x: 0, y: 0 };

                    if( pos.y < window.innerHeight / 2 )
                    {
                        styleTag += 'top-';
                        posAdustment.y = '0%';
                    }
                    else
                    {
                        styleTag += 'bottom-';
                        posAdustment.y = '-100%';
                    }

                    if( pos.x < window.innerWidth / 2 )
                    {
                        styleTag += 'left-';
                        posAdustment.x = '0%';
                    }
                    else
                    {
                        styleTag += 'right-';
                        posAdustment.x = '-100%';
                    }

                    styleTag += 'radius';

                    // set
                    gsap.set( this.$refs.smartPopup, {
                        [styleTag]: '0px',
                        x: posAdustment.x,
                        y: posAdustment.y
                    });

                    this.openedAtOffset = this.offset;

                    this.fixPopupOffset();
                });
            },

            fixPopupOffset()
            {
                // console.log( -this.openedAtOffset, this.offset, -this.openedAtOffset - this.offset );

                // check if the offset changed so far from opening the popup that it no longer justifies having the popup open
                // desktop is set to 300px, mobile depending on width

                if( Math.abs( this.openedAtOffset - this.offset ) > Math.min( 300, window.innerWidth / 2 ) )
                {
                    if( this.popupIsOpen )
                    {
                        this.closePopup();
                    }

                    return;
                }

                // set the popup to the correct offset
                // adjust a little bit when changing offset

                if( this.popupIsOpen )
                {
                    gsap.to( '.popup-wrapper', { left: -this.offset - ( this.openedAtOffset - this.offset ) / 2, duration: 0.4 });
                }
            },

            closePopup()
            {
                this.popupIsOpen = false;
                let prev = this.$el.querySelector( '.bol.selected' );
                if( prev )
                {
                    prev.classList.remove( 'selected' );
                }
            }
        }
    };
</script>
